import { breadcrumbs } from './Breadcrumbs';
import { core_breadcrumbs } from '@core/breadcrumbs';
import { autoinformer_breadcrumbs } from '@autoinformer/breadcrumbs';
import { autocaller_v2_breadcrumbs } from '@autocaller_v2/breadcrumbs';
import { call_tracking_breadcrumbs } from '@call-tracking/breadcrumbs';
import { verification_breadcrumbs } from '@verification/breadcrumbs';
import { db_breadcrumbs } from '@db/breadcrumbs';
import { mailer_breadcrumbs, mailer_messages_beadcrumbs } from '@mailer/breadcrumbs';
import { phone_number_breadcrumbs } from '@phone-number/breadcrumbs';
import { referral_breadcrumbs } from '@referral/breadcrumbs';
import { voice_breadcrumbs } from '@voice/breadcrumbs';
import { notify_breadcrumbs } from '@notify/breadcrumbs';
import { pbx_breadcrumbs } from '@pbx/breadcrumbs';
import { integration_breadcrumbs } from '@integration/breadcrumbs';
import { integrations_breadcrumbs } from '@integrations/breadcrumbs';
import { hlr_breadcrumbs } from '@hlr/breadcrumbs';
// import { amoWidget_breadcrumbs } from '@amo-widget/breadcrumbs';

breadcrumbs.addItems(core_breadcrumbs);
breadcrumbs.addItems(autoinformer_breadcrumbs);
breadcrumbs.addItems(autocaller_v2_breadcrumbs);
breadcrumbs.addItems(call_tracking_breadcrumbs);
breadcrumbs.addItems(verification_breadcrumbs);
breadcrumbs.addItems(db_breadcrumbs);
breadcrumbs.addItems(mailer_breadcrumbs);
breadcrumbs.addItems(mailer_messages_beadcrumbs);
breadcrumbs.addItems(phone_number_breadcrumbs);
breadcrumbs.addItems(referral_breadcrumbs);
breadcrumbs.addItems(voice_breadcrumbs);
breadcrumbs.addItems(notify_breadcrumbs);
breadcrumbs.addItems(pbx_breadcrumbs);
breadcrumbs.addItems(integration_breadcrumbs);
breadcrumbs.addItems(integrations_breadcrumbs);
breadcrumbs.addItems(hlr_breadcrumbs);
// breadcrumbs.addItems(amoWidget_breadcrumbs);
export { breadcrumbs };
